<template>
    <v-card color="black">
        <v-img v-if="!isVideo" aspect-ratio="1.8778">
            <v-btn color="#00000044" class="videocloser" @click="closePlayer()">
                <v-icon color="white">{{icons.close}}</v-icon>
            </v-btn>
            <v-container style="height:100%;">
                <v-row justify="center" style="height:100%;" align="center">
                    <v-col cols="1" class="text-left">
                        <v-btn icon color="#ffffff55" @click="prev()">
                            <v-icon style="transform: scaleY(2)" class="white--text">{{icons.menuleft}}</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="10" class="title white--text text-center">
                        <div style="border: solid thin white; display: inline-block; padding:30px; border-radius: 10px;">
                            <span class="headline">
                                <v-icon class="white--text pb-2"
                                        style="transform: scale(-1.2,1.2);">{{icons.closequote}}
                                </v-icon>
                                   {{note.notesdata.note}}
                                <v-icon class="white--text pb-2"
                                        style="transform: scale(1.2);">{{icons.closequote}}
                                </v-icon>
                            </span>
                        </div>
                    </v-col>
                    <v-col cols="1" class="text-right">
                        <v-btn icon color="#ffffff55" @click="next()">
                            <v-icon style="transform: scaleY(2)" class="white--text">{{icons.menuright}}</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-img>
        <video
                :key="key"
                id="myvideoplayer"
                ref="videoPlayer"
                class="video-js"
                @loadeddata="canPlay($event)"
                @playing="playing=true"
                @pause="playing=false"
                @timeupdate="setP($event)"
        ></video>
        <v-dialog max-width="300" v-model="textdialog">
            <v-card>
                <v-card-text class="pa-1">
                    <v-textarea
                            outlined
                            v-model="notetext"
                            @change="setUnsaved()"
                    />
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-btn text @click="textdialog=false">Done</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import videojs from 'video.js';
  import abLoopPlugin from 'videojs-abloop'

  abLoopPlugin(window, videojs);

  export default {
    name: "ViewWithMenuApp",
    props: {

    },
    data() {
      return {
        player: undefined,
        textheight: 200,
        playing: false,
        videoInterval: false,
        key: false,
        sortkey: undefined, //to be used to decide if the video src has changed... better logic
        leftbtn: undefined,
        rightbtn: undefined,
        fullscreenbtn1: undefined,
        fullscreenbtn2: undefined,
        textrow: undefined,
        pgrbar: undefined,
        sdisplay:undefined,
        ddisplay:undefined,
        saving: false,
        savebutton: undefined,
        count:0,
        storedplaybackrate:1,
        textdialog:false,
        lll:0
      }
    },
    computed: {
      ...mapState(['icons','activenotes', 'noteindex','activesession','cognito']),
      notes() {
        return this.activenotes
      },
      note: {
        get() {
          return this.notes[this.noteindex]
        },
        set(val) {
          let nv = Object.assign({},this.activesession)
          nv.notes[this.noteindex] = val
          nv.notes[this.noteindex].playbackrate = this.player.playbackRate()
          this.setClipBoard(nv)
        }
      },
      start:{
        get(){
          return parseFloat((this.note.notesdata.videotimestamp).toFixed(2))
        },
        set(val){
          this.note.notesdata.videotimestamp = parseFloat(val.toFixed(2))
        }
      },
      end:{
        get(){
          return parseFloat((this.start + this.note.notesdata.duration).toFixed(2))
        },
        set(val){
          this.note.notesdata.duration = val - this.start
        }
      },
      playbackrate(){
        return this.note.notesdata.playbackrate
      },
      readonly(){
        let editable = (this.activesession.edit || this.note.userkey === this.cognito.user.username)
        return !editable
      },
      notetext:{
        get(){
          return this.note.notesdata.note
        },
        set(val){
          this.note.notesdata.note = val
        }
      },
      options() {
        return {
          html5: {
            nativeTextTracks: false
          },
          autoplay: true,
          muted: true,
          fluid: true,
          language: 'en',
          playbackRates: [.25, .5, 1],
          controls: true,
          aspectRatio: '16:9',
          inactivityTimeout: 3 * 60 * 10000, // 3 minutes
          controlBar: {
            progressControl: false,
            volumePanel: false
          },
          sources: this.note.notesdata.src,
          poster: this.note.notesdata.poster,
          plugins: {
            abLoopPlugin: {
              'start': this.start,
              'end': this.end,
              "enabled": true,
              "loopIfBeforeStart": true,
              "loopIfAfterEnd": true,
              "pauseBeforeLooping": false,
              "pauseAfterLooping": false,
              "createButtons": !this.readonly
            }
          },
          userActions: {}
        }
      },
      isVideo() {
        return (this.note) ? (this.note.notetype === 'video' || this.note.notetype === 'marker') : false
      }
    },
    mounted() {
      this.buildPlayer()
    },
    watch: {
      noteindex(n){
        this.count.innerText=n
        this.player.playbackRate(parseFloat(this.note.notesdata.playbackrate))
        if(this.readonly)return
        this.setSaved()
      },
      lll(){ //this is a hack only trigger a timestamp label update
        let em = this;
        if(this.readonly)return
        let n = this.note
        let s = (this.start)
        this.sdisplay.innerText = parseInt(s/60) + ':' + ( (s.length===1)?'0':'' ) +(s%60).toFixed(1)

        let e = this.start+n.notesdata.duration;
        let s2ar = (e%60+'').split('.')
        let s2 = s2ar[0]
        this.ddisplay.innerText = parseInt(e/60) + ':' + ( (s2.length===1)?'0':'' ) +(e%60).toFixed(1)

        setTimeout(function(){
          em.commitChanges()
        },50)
        //this.commitChanges()
      },
      notetext(n){
        this.textrow.innerHTML = n
      },
      playbackrate(n){
        let tp = this.note.notesdata.playbackrate
        console.log('PBWATCHED',n,tp)
        if(tp!==this.player.playbackRate()){
          this.player.playbackRate(n)
        }
      }
    },
    methods: {
      ...mapActions(['get', 'post', 'put', 'playNotes']),
      ...mapMutations(['setNoteIndex','setActiveSession','setClipBoard']),
      Event(e){},
      setUnsaved(){
        //only save individual notes, not if a session is open
        if(this.activesession.notes)return
        this.savebutton.style.visibility = 'inherit'
      },
      setSaved(){
        this.savebutton.style.visibility = 'hidden'
      },
      buildPlayer() {
        let em = this
        this.player = videojs(
          this.$refs.videoPlayer,
          this.options,
          function onPlayerReady() {
            em.Comp()
          })
      },
      createModal(v){
        let cnt = '<div class="row"><div class="col"><div class="v-input__control"><div class="v-input__slot"><fieldset aria-hidden="true"><legend style="width: 66.75px;"><span>&#8203;</span></legend></fieldset><div class="v-text-field__slot"><label for="input-1568" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Text</label><textarea id="input-1568" rows="5"></textarea></div></div><div class="v-text-field__details"><div class="v-messages theme--light"><div class="v-messages__wrapper"></div></div></div></div></div></div>'
        let dv = document.createElement('div');
        dv.style.position='absolute'
        dv.style.width='100%'
        dv.style.height='100%'
        dv.style.zIndex='10'
        dv.style.top='0'
        dv.style.left='0'
        dv.style.backgroundColor = '#000000AA'
        dv.innerHTML = cnt
        let viddiv = document.getElementsByClassName('video-js')[0]
        viddiv.append(dv)

        //var modal = this.player.createModal(cnt);
        // When the modal closes, resume playback.
        //let em = this;
        //modal.on('modalclose', function() {
          //em.player.play();
        //});
      },
      setP(e) {
        //this is ran at @timeupdate
        if(!this.player){
          return
        }
        let c = this.player.currentTime() - this.note.notesdata.videotimestamp
        this.pgrbar.style.width = parseInt(c / this.note.notesdata.duration * 99) + '%'
      },
      setLoop(n) {
        console.log(this.start,this.end)
        this.player.preload('auto')
        let src = n.notesdata.src[0].src
        this.player.abLoopPlugin.applyUrl(src)
        this.player.abLoopPlugin.setStart(this.start).setEnd(this.end)
        //this.player.abLoopPlugin.setEnd(this.end)
        this.player.abLoopPlugin.goToStart().playLoop()
        this.player.playbackRate(this.note.notesdata.playbackrate)
        this.textrow.innerHTML = n.notesdata.note;
        this.lll++
      },
      canPlay(e) {
        var tnt = undefined
        if (this.isVideo) this.play()
      },
      replay() {
        this.player.currentTime(this.start)
      },
      play() {
        //build out normal api to videoJs
        this.player.playbackRate(this.note.notesdata.playbackrate)
        this.player.play();
        this.playing = true;
      },
      pause() {
        this.player.pause();
        this.playing = false;
      },
      prev() {
        let i = this.noteindex-1
        if(i<0)return
        this.setNoteIndex(i)
        this.leftbtn.style.visibility = (i <= 0) ? 'hidden' : 'inherit'
        this.rightbtn.style.visibility = 'inherit'
        if(this.note.notetype==='text'){
          this.player.hide()
        }else{
          this.player.show()
          this.setLoop(this.note)
        }
      },
      next() {
        let i = this.noteindex+1
        if(i>this.notes.length-1)return
        this.setNoteIndex(i)
        this.rightbtn.style.visibility = (i >= this.activenotes.length - 1) ? 'hidden' : 'inherit'
        this.leftbtn.style.visibility = 'inherit'
        if(this.note.notetype==='text'){
          this.player.hide()
        }else{
          this.player.show()
          this.setLoop(this.note)
        }
      },
      async Options() {
        //check for video src diff and use it to avoid the jittery note switch
        //might need to pass it all in better, to avoid a full-screen exit
        console.log('Setting Options')
        await this.player.options(this.options)
      },
      closePlayer() {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        if (this.isVideo) {
          this.player.dispose()
          this.player = false
        }
        this.playNotes({list:undefined,index:false})//handles the $store
      },
      Comp() {
        let em = this;
        let viddiv = document.getElementsByClassName('video-js')[0]

        let closebtn = this.createButton('mdi-close')
        closebtn.style.position = "absolute"
        closebtn.style.top = "10px"
        closebtn.style.right = "5px"
        closebtn.classList.add('v-btn--round')
        closebtn.addEventListener('click', function () {
          em.closePlayer()
        })
        viddiv.append(closebtn)

        //text div
        let tdiv = document.createElement('div')
        tdiv.style.position = "absolute"
        tdiv.style.bottom = "30px"
        tdiv.style.backgroundColor = "#00000085"
        tdiv.addEventListener('playbackrateactive', function (v) {
          console.log('PBR', v)
        })
        this.player.controlBar.playbackRateMenuButton.on('mouseenter', function () {
          tdiv.style.visibility = 'hidden'
        })
        this.player.controlBar.playbackRateMenuButton.on('mouseleave', function () {
          tdiv.style.visibility = 'inherit'
        })
        let dcls = "container container--fluid py-0"
        tdiv.classList.add(...dcls.split(' '))
        let rdiv = document.createElement('div')
        rdiv.classList.add('row')
        tdiv.append(rdiv)
        let cldiv = document.createElement('div')
        let clcls = "text-center white--text subtitle-2 font-weight-light col"
        cldiv.classList.add(...clcls.split(' '))
        this.textrow = cldiv;
        this.textrow.innerHTML = this.notetext
        rdiv.append(cldiv)
        viddiv.append(tdiv)


        let rbtn = this.createButton('mdi-menu-right-outline')
        rbtn.style.position = "absolute"
        rbtn.style.top = "50%"
        rbtn.style.right = "5px"
        rbtn.classList.add('v-btn--round')
        rbtn.style.transform = 'scaleY(2)'
        if (this.noteindex >= this.notes.length) rbtn.style.visibility = 'hidden'
        rbtn.addEventListener('click', function () {
          em.next()
        })
        rbtn.style.backgroundColor="#0f2944dd"
        this.rightbtn = rbtn;
        viddiv.append(this.rightbtn)
        if(!this.activesession.notes){
          this.rightbtn.style.visibility = 'hidden'
        }

        let lbtn = this.createButton('mdi-menu-left-outline')
        lbtn.style.position = "absolute"
        lbtn.style.top = "50%"
        lbtn.style.left = "5px"
        lbtn.classList.add('v-btn--round')
        lbtn.style.transform = 'scaleY(2)'
        if (this.noteindex === 0) lbtn.style.visibility = 'hidden'
        lbtn.addEventListener('click', function () {
          em.prev()
        })
        lbtn.style.backgroundColor="#0f2944dd"
        this.leftbtn = lbtn
        viddiv.append(this.leftbtn)
        if(!this.activesession.notes){
          this.leftbtn.style.visibility = 'hidden'
        }

        let fsbtn = this.createButton('mdi-fullscreen')
        fsbtn.style.position = "absolute"
        fsbtn.style.top = "12px"
        fsbtn.style.left = "9px"
        fsbtn.style.transform = 'scale(1.4)'
        fsbtn.classList.add('v-btn--round')
        fsbtn.addEventListener('click', function () {
          em.player.requestFullscreen()
        })
        this.fullscreenbtn1 = fsbtn
        viddiv.append(this.fullscreenbtn1)

        let fsbtn2 = this.createButton('mdi-fullscreen-exit')
        fsbtn2.style.position = "absolute"
        fsbtn2.style.top = "12px"
        fsbtn2.style.left = "9px"
        fsbtn2.style.transform = 'scale(1.4)'
        fsbtn2.style.display = "none"
        fsbtn2.classList.add('v-btn--round')
        fsbtn2.addEventListener('click', function () {
          em.player.exitFullscreen()
        })
        this.fullscreenbtn2 = fsbtn2
        viddiv.append(this.fullscreenbtn2)

        document.addEventListener('fullscreenchange', function () {
          if (document.fullscreenElement) {
            em.fullscreenbtn1.style.display = 'none'
            em.fullscreenbtn2.style.display = 'inherit'
          } else {
            em.fullscreenbtn1.style.display = 'inherit'
            em.fullscreenbtn2.style.display = 'none'
          }
        })


        let counter = this.createCounterButton()
        counter.style.position = "absolute"
        counter.style.top = "12px"
        counter.style.left = "50px"
        counter.style.transform = "scale(1.4)"
        counter.classList.add('v-btn--round')
        viddiv.append(counter)
        if(!this.activesession.notes){
          counter.style.visibility = 'hidden'
        }

        if(!this.readonly){
          let txtbutton = this.createButton('mdi-alpha-t')
          txtbutton.style.position = "absolute"
          txtbutton.style.top = "52px"
          txtbutton.style.left = "9px"
          txtbutton.style.transform = 'scale(1.4)'
          txtbutton.classList.add('v-btn--round')
          txtbutton.addEventListener('click',function(){
            em.pause()
            em.textdialog = true
            //em.createModal('hi')
          })
          viddiv.append(txtbutton)
        }

        this.createSeekBar()

        if (this.isVideo) {
          this.setLoop(this.note)
        } else {
          this.player.hide()
        }

      },
      createButton(icon) {
        let btn = document.createElement('button')
        let cls = "ma-0 v-btn v-btn--depressed theme--light ripple"//this is how lazy i am
        btn.classList.add(...cls.split(' '))
        let spn = document.createElement('span')
        spn.classList.add("v-btn_content", "white--text")
        btn.appendChild(spn)
        let icn = document.createElement('icon')
        let icls = "v-icon notranslate mdi theme--light " + icon
        icn.classList.add(...icls.split(' '))
        icn.style.cssText = "color: white;"
        spn.appendChild(icn)
        btn.style.cssText = "background-color: rgba(0, 0, 0, 0.333);"
        return btn
      },
      createCounterButton() {
        let size=30
        let btn = document.createElement('div')
        let spn = document.createElement('span')
        spn.classList.add("v-btn_content", "white--text")
        spn.style.cssText="font-size:2em;"
        spn.innerText=this.noteindex
        this.count = spn
        btn.appendChild(this.count)
        btn.style.cssText = "background-color: rgba(0, 0, 0, 0.333);height:25px;width:25px;border: solid .5px white;text-align:center;padding-top:1px;"
        return btn
      },
      createSeekBar() {
        let em = this;
        let sk = document.createElement('div')
        sk.style.width = '100%';
        sk.style.height = '8px'
        sk.style.border = 'solid thin white';
        sk.style.borderRadius = '3px'
        sk.style.position = 'absolute';
        sk.style.bottom = '34px';
        sk.style.left = '0'
        sk.style.overflow = 'hidden'
        sk.style.boxShadow = '0 0 3px white'
        sk.addEventListener('click', function (e) {
          let pct = e.offsetX / sk.clientWidth
          let npos = parseInt(em.note.notesdata.duration * pct)
          em.player.currentTime(npos)
        })
        this.player.controlBar.playbackRateMenuButton.on('mouseenter', function () {
          sk.style.visibility = 'hidden'
        })
        this.player.controlBar.playbackRateMenuButton.on('mouseleave', function () {
          sk.style.visibility = 'inherit'
        })

        let br = document.createElement('div')//progressbar For Note
        br.style.height = '100%';
        br.style.width = '2%'
        br.style.backgroundColor = '#fdfdfd';
        br.style.position = 'absolute';
        br.style.left = '0'
        this.pgrbar = br

        sk.append(br)
        this.player.el().append(sk)
        if(!this.readonly){
          this.createTimeControls()
        }
      },
      createTimeControls(){
        let em = this;
        let sdiv = document.createElement('div')
        sdiv.style.position = 'absolute';

        let seekleft = this.createSeekButton()
        seekleft.style.left = '5px';
        seekleft.addEventListener('click', function () {
          em.player.abLoopPlugin.adjustStart(-.2)
          em.player.abLoopPlugin.goToStart().playLoop()
          em.start -= .2
          em.lll++
          em.setUnsaved()
        })
        seekleft.addEventListener('mousedown', function () {
          this.style.left = '3px'
        })
        seekleft.addEventListener('mouseup', function () {
          this.style.left = '5px'
        })
        this.player.el().append(seekleft)
        let icn = document.createElement('icon')
        icn.classList.add('mdi-chevron-double-left', 'mdi')
        icn.style.fontSize = '2em'
        seekleft.appendChild(icn)

        let seekrightStart = this.createSeekButton()
        seekrightStart.style.left = '60px';
        seekrightStart.style.textAlign = 'right'
        seekrightStart.addEventListener('click', function () {
          em.player.abLoopPlugin.adjustStart(.2)
          em.start += .2
          em.lll--
          em.setUnsaved()
        })
        seekrightStart.addEventListener('mousedown', function () {
          seekrightStart.style.left = '62px'
        })
        seekrightStart.addEventListener('mouseup', function () {
          seekrightStart.style.left = '60px'
        })
        this.player.el().append(seekrightStart)
        icnr = document.createElement('icon')
        icnr.classList.add('mdi-chevron-double-right', 'mdi')
        icnr.style.fontSize = '2em'
        seekrightStart.appendChild(icnr)


        let seekleftEnd = this.createSeekButton()
        seekleftEnd.style.right = '60px';
        seekleftEnd.addEventListener('click', function () {
          em.player.abLoopPlugin.adjustEnd(-.2)
          //em.d -= .2
          // em.note.notesdata.duration -= .2
          em.end -= .2
          em.lll++
          em.setUnsaved()
        })
        seekleftEnd.addEventListener('mousedown', function () {
          this.style.right = '62px'
        })
        seekleftEnd.addEventListener('mouseup', function () {
          this.style.right = '60px'
        })
        this.player.el().append(seekleftEnd)
        let icn2 = document.createElement('icon')
        icn2.classList.add('mdi-chevron-double-left', 'mdi')
        icn2.style.fontSize = '2em'
        seekleftEnd.appendChild(icn2)


        let seekright = this.createSeekButton()
        seekright.style.right = '5px';
        seekright.style.textAlign = 'right'
        seekright.addEventListener('click', function () {
          em.player.abLoopPlugin.adjustEnd(.2)
          //em.d += .2
          em.lll--
          //em.note.notesdata.duration += .2
          em.end += .2
          em.setUnsaved()
        })
        seekright.addEventListener('mousedown', function () {
          seekright.style.right = '2px'
        })
        seekright.addEventListener('mouseup', function () {
          seekright.style.right = '5px'
        })
        this.player.el().append(seekright)
        let icnr = document.createElement('icon')
        icnr.classList.add('mdi-chevron-double-right', 'mdi')
        icnr.style.fontSize = '2em'
        seekright.appendChild(icnr)

        let bigSeekLeft = this.createSeekButton()
        bigSeekLeft.style.left = '8px'
        bigSeekLeft.style.bottom = '51px'
        bigSeekLeft.style.transform = 'scale(1.3)'
        let bicnr = document.createElement('icon')
        bicnr.classList.add('mdi-chevron-double-left', 'mdi')
        bicnr.style.fontSize = '2em'
        bigSeekLeft.appendChild(bicnr)
        bigSeekLeft.addEventListener('click',function(){
          em.start -= 1
          em.player.abLoopPlugin.adjustStart(-1).goToStart().playLoop()
          em.lll++
          em.setUnsaved()
        })
        this.player.el().append(bigSeekLeft)

        let bigSeekRight = this.createSeekButton()
        bigSeekRight.style.right = '8px'
        bigSeekRight.style.bottom = '51px'
        bigSeekRight.style.transform = 'scale(1.3)'
        let bicnl = document.createElement('icon')
        bicnl.classList.add('mdi-chevron-double-right', 'mdi')
        bicnl.style.fontSize = '2em'
        bigSeekRight.appendChild(bicnl)
        bigSeekRight.addEventListener('click',function(){
          em.end += 1
          em.player.abLoopPlugin.adjustEnd(1)
          em.lll++
          em.setUnsaved()
        })
        this.player.el().append(bigSeekRight)


        let td = this.createTimeDisplay()
        td.style.left = '26px';
        td.style.textAlign = 'center'
        td.style.lineHeight = '20px'
        td.style.paddingLeft = '3px'
        td.style.paddingRight = '3px'
        this.sdisplay = td;
        this.player.el().append(td)

        let td2 = this.createTimeDisplay()
        td2.style.right = '26px';
        td2.style.textAlign = 'center'
        td2.style.lineHeight = '20px'
        td2.style.paddingLeft = '3px'
        td2.style.paddingRight = '3px'
        this.ddisplay = td2;
        this.player.el().append(td2)

        this.savebutton = this.createButton('mdi-content-save-outline')
        this.savebutton.style.position = 'absolute'
        this.savebutton.style.right = '20px'
        this.savebutton.style.top = '52px'
        this.savebutton.style.transform = 'scale(1.4)'
        this.savebutton.addEventListener('click', function () {
          em.editNote()
        })
        this.player.el().append(this.savebutton)
        let sb = document.getElementsByClassName('mdi-content-save-outline')
        sb[0].classList.add('green--text')
        this.savebutton.style.visibility = 'hidden'
      },
      createSeekButton() {
        let d = document.createElement('div')
        d.style.width = '20px'
        d.style.height = '20px'
        d.style.backgroundColor = 'darkblue';
        d.style.boxShadow = '0 0 3px darkblue'
        d.style.position = 'absolute';
        d.style.bottom = '28px';
        d.style.borderRadius = '5px'
        d.style.cursor = 'pointer'
        d.addEventListener('mouseenter', function () {
          d.style.backgroundColor = 'blue'
          d.style.boxShadow = '0 0 5px blue'
        })
        d.addEventListener('mouseleave', function () {
          d.style.backgroundColor = 'darkblue'
          d.style.boxShadow = '0 0 3px darkblue'
        })
        return d

      },
      createTimeDisplay(){
        let d = document.createElement('div')
        d.style.height = '20px'
        d.style.backgroundColor = 'darkblue';
        d.style.boxShadow = '0 0 3px darkblue'
        d.style.position = 'absolute';
        d.style.bottom = '28px';
        d.style.borderRadius = '5px'
        return d
      },
      createMarkers(seekbar) {
        let d = document.createElement('div')
        d.style.width = '4%'
        d.style.height = '10px'
        d.style.backgroundColor = 'red';
        d.style.boxShadow = '0,0,3px,blue'
        d.style.position = 'absolute';
        d.style.left = '20px';
        //d.style.bottom = '30px';
        console.log(d)
        seekbar.append(d)
      },
      commitChanges(){
        if(!this.activesession.notes)return
        if(!this.activesession || this.readonly)return
        let tmp = Object.assign({},this.activesession)
        tmp.notes[this.noteindex]=this.note
        tmp.notes[this.noteindex].notesdata.playbackrate=this.player.playbackRate()
        this.setActiveSession(tmp)
      },
      async editNote() {
        this.saving = true;
        this.savebutton.classList.add('v-btn--loading')
        let p = 'https://videos.athleteforlife.org/'+this.note.notesdata.partkey+'/'+this.note.notesdata.sortkey+'/thumbs-'+this.note.notesdata.sortkey+'-'
        let poster = p + parseInt(this.start).toString().padStart(5, '0') + '.jpg'

        let data = {
          id: this.note.noteid,
          type: 'video',
          tag: this.notetags,
          partkey: this.note.notesdata.partkey,
          sortkey: this.note.notesdata.sortkey,
          // notestart: (Math.round(this.s * 100) / 100),
          // noteduration: (Math.round(this.d * 100) / 100),
          notestart: this.start,
          noteduration: (Math.round(this.note.notesdata.duration * 100) / 100),
          body: this.note.notesdata.note,
          noteplaybackrate: this.player.playbackRate(),
          sessionpartkey: this.activesession.partkey,
          sessionsortkey: this.activesession.sortkey,
          //locationframe: this.imgurl + this.fname + '.jpg',
          poster: poster,
          //src: [{type:'video/mp4',src:this.src}]
        }
        let response = await this.put({path: 'api/notes/savenote', body: data})
        this.saving = false
        this.savebutton.classList.remove('v-btn--loading')
        this.savebutton.style.visibility = 'hidden'
        console.log(response)
        this.commitChanges()
      },
    },
    beforeDestroy() {
      console.log('DESTROY')
      if (this.player) {
        this.player.dispose()
      }
    }
  }

</script>

<style scoped>
    .my_overlay {
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
        display: none;
        overflow: hidden;
    }

    .hide {
        visibility: hidden;
    }

    .videooverlay {
        z-index: inherit;
        background-color: rgba(0, 0, 0, 0.133);
        border-color: rgba(0, 0, 0, 0.133);
    }

    .ol {
        color: #0f2944;
        -webkit-text-fill-color: #0f2944; /* Will override color (regardless of order) */
        -webkit-text-stroke-width: 1px;
        -webkit-text-stroke-color: #FFFFFFdd;
        transform: scale(1.2);
    }

    .videocloser {
        position: absolute;
        top: 10px;
        right: 15px;
        z-index: 2000 !important;
    }


    .menubar {
        display: block;
        position: absolute;
        bottom: 30px;
        left: 0;
        z-index: 12999;
        color: #fff;
        background-color: rgba(0, 0, 0, .4);
        width: 100vw;
        /*cursor: pointer;*/
        /*text-align: center;*/
    }

    .menubar2 {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 12999;
        color: #fff;
        background-color: rgba(0, 0, 0, .4);
        width: 100%;
        /*cursor: pointer;*/
        /*text-align: center;*/
    }
</style>